module.exports = __webpack_public_path__ + "img/icon-flash.f20011f3.svg";